import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { SideBarLink } from '../SideNavBar'
import { UserDetails } from './UserDetails'
import { isMobileDevice } from '../../helpers'
import { useSelector } from 'react-redux'
import { Link } from '@reach/router'
import { GlobalSearch} from './GlobalSearch'
import SlidingPane from 'react-sliding-pane'
import {GlobalSearchFormDisplay} from "./GlobalSearchFormDisplay";

export const Header = () => {
  const [search, setSearch] = useState<string>()
  const [currentKey, setCurrentKey] = useState<string>()
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const { productName } = useSelector((state) => state.application)
      const { clientName } = useSelector((state) => state.application)
  const { user } = useSelector((state) => state.auth)
  return (
    <>
      <SlidingPane
        overlayClassName="on-top"
        width={'70vw'}
        isOpen={search && isPaneOpen?true:false}
        title={'Search'}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <GlobalSearch
          currentKey={currentKey}
          onChange={(key:string) => setCurrentKey(key)}
          search={search}
        />
      </SlidingPane>
      <ReactBootstrap.Navbar
        sticky="top"
        bg="dark"
        style={{ zIndex: 999, padding: '8px' }}
      >
        <ReactBootstrap.Navbar.Brand>
          <Link to={'/'}>
            <div className="ml-2 text-white">{productName}</div>
             <div style={{fontSize:"12px"}} className="ml-2 text-white">{clientName}</div>
          </Link>
        </ReactBootstrap.Navbar.Brand>
        {user && (
          <span
            style={{ position: 'absolute', right: '13%' }}
            className={'float-right'}
          >
            <GlobalSearchFormDisplay
              onSubmit={(value:string) => {
                setSearch(value)
                setIsPaneOpen(true)
              }}
            />
          </span>
        )}

        <ReactBootstrap.Navbar.Collapse id="navbarCollapse3">
          <ReactBootstrap.Nav
            className="pr-3"
            style={{ position: 'absolute', right: '20px' }}
          >
            {!user ? (
              <>
                <ReactBootstrap.Nav.Link href={'/'} active />

                <ReactBootstrap.NavDropdown
                    id={"tokenDropDown"}
                  className="text-white"
                  drop={isMobileDevice ? 'down' : 'start'}
                  title={<span className="text-white">Token</span>}
                >
                  <ReactBootstrap.NavDropdown.Item href="/token">
                    Entry
                  </ReactBootstrap.NavDropdown.Item>
                  <ReactBootstrap.NavDropdown.Divider />
                  <ReactBootstrap.NavDropdown.Item href="/token/display">
                    Display
                  </ReactBootstrap.NavDropdown.Item>
                  <ReactBootstrap.NavDropdown.Divider />
                  <ReactBootstrap.NavDropdown.Item href="/token/qr">
                    QR Display
                  </ReactBootstrap.NavDropdown.Item>
                </ReactBootstrap.NavDropdown>

                <ReactBootstrap.Nav.Link>
                  <SideBarLink className="pr-4 " to="/login">
                    Login
                  </SideBarLink>
                </ReactBootstrap.Nav.Link>
              </>
            ) : (
              <ReactBootstrap.NavItem className={'mr-3'}>
                <ReactBootstrap.Dropdown     id={"userDetailsDropDown"}>
                    {user && <UserDetails {...user} />}
                </ReactBootstrap.Dropdown>
              </ReactBootstrap.NavItem>
            )}
          </ReactBootstrap.Nav>
        </ReactBootstrap.Navbar.Collapse>
      </ReactBootstrap.Navbar>
    </>
  )
}
